import React from 'react';
import PropTypes from 'prop-types';

const Microwave = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={color}
      d="M20.066 4H3.986C2.896 4 2 4.897 2 5.986v10.186c0 1.025.705 1.858 1.666 1.986v1.858h.576v-1.858h15.504v1.858h.576v-1.858c.961-.128 1.666-.96 1.666-1.986V5.986C22.116 4.896 21.219 4 20.066 4ZM3.986 17.581c-.769 0-1.41-.64-1.41-1.409V5.986c0-.769.641-1.41 1.41-1.41h11.595v13.005H3.986Zm17.49-1.409c0 .769-.641 1.41-1.41 1.41h-3.908V4.576h3.908c.769 0 1.41.64 1.41 1.409v10.186Z"
    />
    <path
      fill={color}
      d="M12.443 5.73H5.716c-1.153 0-2.05.897-2.05 1.986v6.79c0 1.09.897 1.986 1.986 1.986h6.79a1.996 1.996 0 0 0 1.986-1.986v-6.79c.064-1.09-.832-1.986-1.986-1.986Zm1.409 8.776c0 .77-.64 1.41-1.41 1.41H5.717c-.769 0-1.41-.64-1.41-1.41v-6.79c0-.77.641-1.41 1.41-1.41h6.79c.77 0 1.41.64 1.41 1.41v6.79h-.064ZM20.066 14.186h-2.563c-.192 0-.32.128-.32.32v1.666c0 .192.128.32.32.32h2.563c.192 0 .32-.128.32-.32v-1.73c0-.128-.128-.256-.32-.256Zm-.256 1.73h-1.922v-1.09h1.922v1.09ZM20.066 5.73h-2.563c-.192 0-.32.128-.32.32v6.79c0 .193.128.321.32.321h2.563c.192 0 .32-.128.32-.32V5.986c0-.128-.128-.256-.32-.256Zm-.256 6.79h-1.922V6.306h1.922v6.214Z"
    />
    <path
      fill={color}
      d="M11.482 10.214c0-.192-.129-.32-.32-.32H6.932c-.192 0-.32.128-.32.32 0 1.474.704 2.69 1.665 3.075h-3.01v.577h7.623v-.577H9.816c.96-.384 1.665-1.601 1.665-3.075Zm-4.229.32h3.588c-.128 1.346-.833 2.37-1.794 2.37-.897 0-1.666-1.024-1.794-2.37Z"
    />
  </svg>
);

Microwave.propTypes = {
  color: PropTypes.string
};

export default Microwave;
